import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const DATE_ONLY_FORMAT = 'YYYY-MM-DD';

export type DateOnlyInput = string | Date;

const toDateOnlyDayjs = (value: DateOnlyInput) => {
  const date =
    value instanceof Date
      ? dayjs(value)
      : dayjs(value, DATE_ONLY_FORMAT, true);

  if (!date.isValid()) {
    throw new Error(`Expected date-only value in ${DATE_ONLY_FORMAT} format`);
  }

  return date;
};

export const toExclusiveDate = (inclusiveDate: DateOnlyInput): string =>
  toDateOnlyDayjs(inclusiveDate).add(1, 'day').format(DATE_ONLY_FORMAT);

export const toInclusiveDate = (exclusiveDate: DateOnlyInput): string =>
  toDateOnlyDayjs(exclusiveDate).subtract(1, 'day').format(DATE_ONLY_FORMAT);

export const toDateOnlyString = (
  date: string | Date | undefined | null
): string | undefined => {
  if (date == null) return undefined;

  return toDateOnlyDayjs(date).format(DATE_ONLY_FORMAT);
};

export const dateOnlyToDate = (
  value: string | undefined | null
): Date | undefined => {
  if (!value) return undefined;

  return toDateOnlyDayjs(value).toDate();
};
